// Plausible custom-event registry — single source of truth for event names.
//
// Two emission paths exist in this codebase:
//
//   1. Server-bridged events (fired from Rails controllers via
//      `plausible_event!(:name, props)`; the layout renders a
//      <div data-controller="track"> from flash). The Ruby allowlist
//      lives at app/controllers/concerns/plausible_event_queue.rb;
//      every constant in *that* allowlist must also appear here.
//
//   2. Client-only events (fired directly from a Stimulus controller
//      via `track()` from app/javascript/lib/track.js). These do NOT
//      appear in the Ruby allowlist — there is no server path.
//
// Adding a new event:
//   - Server-bridged: add the constant here AND to PLAUSIBLE_EVENTS in plausible_event_queue.rb.
//   - Client-only:   add the constant here only.
//   - In both cases: document the event in doc/marketing/analytics.md.

// --- Server-bridged events ---
export const SIGNUP_COMPLETED = 'signup_completed'
export const PLAN_CHANGED = 'plan_changed'
export const INVITATION_SENT = 'invitation_sent'
export const CONTACT_REQUEST_SUBMITTED = 'contact_request_submitted'

// --- Client-only events (no Ruby allowlist; emitted from Stimulus controllers) ---
export const ROI_CALCULATED = 'roi_calculated'
